export const ARIALABLES_NAME = {
    english: { back: 'Back', close: 'Close' },
    spanish: { back: 'espalda', close: 'Cerrar' },
    hindi: { back: 'वापस', close: 'बंद करे' }
};

export const PANELPOSITION = {
    Left: 'left',
    Right: 'right'
};

export const ICONVALUE = {
    Back: 'backIcon',
    Cancel: 'cancelIcon'
};